/**
 * logoTreatment.ts — CSS filter para el logo de la liga según su tratamiento y el fondo.
 *
 * treatment:
 *   'light' — logo de colores claros (blanco, lima). Funciona sobre fondos oscuros.
 *   'dark'  — logo de colores oscuros (negro, navy). Funciona sobre fondos claros.
 *   'auto'  — se trata igual que 'light' (el logo SVG existente es blanco/claro).
 *
 * bgType:
 *   'dark'  — fondo oscuro (navy, primary). El logo light va directo; el dark se invierte a blanco.
 *   'light' — fondo claro (blanco, lima, gris). El logo dark va directo; el light se oscurece.
 */
export function getLogoFilter(
  treatment: string | null | undefined,
  bgType: 'dark' | 'light',
): string | undefined {
  const t = treatment ?? 'light';
  if (bgType === 'dark') {
    return t === 'dark' ? 'brightness(0) invert(1)' : undefined;
  } else {
    return t !== 'dark' ? 'brightness(0)' : undefined;
  }
}
